import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./DataManagement.css";

import datasolution from "../../assests/datasolution-img.svg"
import heroImg from "../../assests/Background-img.svg";

// Components
import ARVRSecondpage from "../Ar-vrServicespage/ARVRSecondpage";

import ContactFormModal from "../header/ContactFormModal";
import CoreServices from "../coreServices/coreServices";
import BusinessValue from "../BusinessValue/BusinessValue";
import WhyIOTSection from "../WhyIOTSection/WhyIOTSection";
import ArBusiness from "../Ar-vrServicespage/ArBusiness";
import SoftwareCoreServices from "../SoftwareCoreServices/SoftwareCoreServices";
import AICoreServices from "../AI-CoreServices/AICoreServices";
import DataCoreServices from "../DataCoreServices/DataCoreServices";
import { useNavigate } from "react-router-dom";
// Define service type  
type Service = {
  id: string;
  title: string;
  icon: string;
  items: string[];
  hasRoute: boolean;
  routePath?: string;
};

const DataManagement: React.FC = () => {
  const navigate = useNavigate();
  const [activeService] = useState("ar");
    const [showContactForm, setShowContactForm] = useState(false);

  const handleServiceClick = (service: Service) => {
    if (service.hasRoute && service.routePath) {
      window.location.href = service.routePath;
    }
  };

  return (
    <div className="datasolution-services-page">
      {showContactForm && <ContactFormModal onClose={() => setShowContactForm(false)} />}
      {/* Hero Section */}
<section
  className="hero-section-datasolution d-flex align-items-center justify-content-center"
  style={{
    backgroundImage: `url(${heroImg})`,
    backgroundSize: "cover",
  }}
>
  <div className="container-datasolution text-center">
    <h1 className="hero-title-datasolution">Data & Analytics</h1>
    <p className="hero-subtitle-datasolution">
     Unlock the power of your data with enterprise-grade analytics and management solutions.
    </p>
    <button
      className=" hero-button-datasolution"
      onClick={() => navigate("/Contact-Us")}
    >
      Get in Touch
    </button>
  </div>
</section>

      {/* Other Sections */}
      <DataCoreServices/>
      <BusinessValue/>
      <WhyIOTSection/>
      <ArBusiness/>
    </div>
  );
};

export default DataManagement;
